<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

const props = defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()

const DISPLAYS = [
  { value: 'accordion', label: t('site.f.tabs_accordion.opt_accordion', 'Accordion') },
  { value: 'tabs', label: t('site.f.tabs_accordion.opt_tabs', 'Tabs') }
] as const

const addPanel = () => {
  props.block.data.panels = [...(props.block.data.panels ?? []), { title: '', html: '<p></p>' }]
}
const removePanel = (i: number) => {
  props.block.data.panels?.splice(i, 1)
}
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.common.heading_optional', 'Heading (optional)')">
    <UInput
      v-model="block.data.headline"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.tabs_accordion.style', 'Style')">
    <SiteEditorOptionToggle
      :options="DISPLAYS"
      :model-value="block.data.display ?? 'accordion'"
      @update:model-value="block.data.display = $event as 'tabs' | 'accordion'"
    />
  </UFormField>

  <SiteEditorArrayItemCard
    v-for="(panel, i) in block.data.panels ?? []"
    :key="i"
    :label="`${t('site.f.tabs_accordion.item_label', 'Panel')} ${i + 1}`"
    @remove="removePanel(i)"
  >
    <UInput
      v-model="panel.title"
      :placeholder="t('site.f.tabs_accordion.panel_title', 'Panel title')"
      class="w-full"
    />
    <SiteEditorRichTextField
      :model-value="panel.html ?? ''"
      @update:model-value="panel.html = $event"
    />
  </SiteEditorArrayItemCard>

  <UButton
    size="sm"
    variant="outline"
    color="neutral"
    icon="i-lucide-plus"
    @click="addPanel"
  >
    {{ t('site.f.tabs_accordion.add_item', 'Add panel') }}
  </UButton>
</template>
